
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterDcdcOn as ObiConverterDcdcOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-dcdc-on.js';
 
 
 

 
 export const ObiConverterDcdcOn = createComponent({
   react: React,
   tagName: 'obi-converter-dcdc-on',
   elementClass: ObiConverterDcdcOnElement,
   events: {
     
   }
  });
 
 